export enum EValidationSeverity {
  unknown, error, promptBoolean, warn, info, success, promptNote,
}

export interface IValidationMessage {
  id?: string;
  date?: Date;
  title: string;
  type: EValidationSeverity;
  description?: string;
  onRenderDescription?: () => JSX.Element
  inner?: IValidationMessage[];
  value?: any;
  resolved?: boolean;
  onChange?: (value: any) => void;
}

export interface IValidationViewProperties {
  validations: IValidationMessage[];
}